<template>
  <div>
    <woot-modal-header
      :header-title="
        isEditMode
          ? $t('AI.KNOWLEDGE.EDIT_URL.TITLE_FILE')
          : $t('AI.KNOWLEDGE.ADD_URL.TITLE_FILE')
      "
    >
      <p>
        {{
          isEditMode
            ? $t('AI.KNOWLEDGE.EDIT_URL.SUB_TITLE')
            : $t('AI.KNOWLEDGE.ADD_URL.SUB_TITLE')
        }}
      </p>
    </woot-modal-header>
    <div class="modal-content">
      <InputField
        v-model="knowledge.name"
        :label="$t('AI.KNOWLEDGE.ADD_URL.NAME.LABEL')"
        :placeholder="$t('AI.KNOWLEDGE.ADD_URL.NAME.PLACEHOLDER')"
        :error="
          $v.knowledge.name.$error ? $t('AI.KNOWLEDGE.ADD_URL.NAME.ERROR') : ''
        "
        :info-list="[]"
        @blur="$v.knowledge.name.$touch"
      />

      <InputField
        v-model="knowledge.url"
        :label="$t('AI.KNOWLEDGE.ADD_URL.URL.LABEL')"
        :placeholder="$t('AI.KNOWLEDGE.ADD_URL.URL.PLACEHOLDER')"
        :error="
          $v.knowledge.url.$error ? $t('AI.KNOWLEDGE.ADD_URL.URL.ERROR') : ''
        "
        :info-list="[]"
        @blur="$v.knowledge.url.$touch"
      />

      <div>
        <woot-button
          :is-disabled="uiFlags.isKnowledgeCreating"
          :is-loading="uiFlags.isKnowledgeCreating"
          @click="onSubmit"
        >
          {{
            isEditMode
              ? $t('AI.KNOWLEDGE.EDIT.BTNS.SUBMIT')
              : $t('AI.KNOWLEDGE.ADD_URL.BTNS.SUBMIT')
          }}
        </woot-button>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import InputField from 'components/ui/inputs/InputField.vue';
import { url, required } from 'vuelidate/lib/validators';

export default {
  components: {
    InputField,
  },
  mixins: [alertMixin],
  props: {
    initialItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      knowledge: {
        name: '',
        url: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'tools/getUIFlags',
    }),
    isEditMode() {
      return this.initialItem && this.initialItem.id;
    },
  },
  validations() {
    return {
      knowledge: {
        name: { required },
        url: { required, url },
      },
    };
  },
  watch: {
    initialItem: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.name) {
          this.knowledge.name = newVal.name;
        }
        if (newVal && newVal.file_url) {
          this.knowledge.url = newVal.file_url;
        }
      },
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        const payload = new FormData();

        if (this.isEditMode) {
          payload.append('id', this.initialItem.id);
        }

        payload.append('name', this.knowledge.name);
        payload.append('kind', 'url');
        payload.append('file_url', this.knowledge.url);

        if (this.isEditMode) {
          await this.$store.dispatch('tools/updateKnowledgeById', {
            knowledge_id: this.initialItem.id,
            payload,
          });
          this.showAlert(this.$t('AI.KNOWLEDGE.EDIT_URL.ALERTS.EDIT_SUCCESS'));
        } else {
          await this.$store.dispatch('tools/createKnowledge', payload);
          this.showAlert(this.$t('AI.KNOWLEDGE.ADD_URL.ALERTS.ADD_SUCCESS'));
        }

        this.$emit('onSubmit');
        this.$emit('onClose');
      } catch (error) {
        console.error('Error in AddUrlModal onSubmit:', error);
        this.showErrAlert(error, this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tool_file {
  display: grid;
  grid-template-columns: 25px 1fr 25px;
  gap: 10px;
}
</style>
